"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var noAlpha = /[^a-zA-Z\u00B4\u00C0-\u00FF ]/g;
var whiteSpaceRegex = /\ {2,}/g;
var getClipped = function getClipped(limit, value) {
  return limit && value.length > limit ? value.substring(0, limit) : value;
};
var getHasError = function getHasError(onlyError, error, touched) {
  return onlyError ? error : touched && error;
};
function AlphaInput(props) {
  var limit = props.limit,
    regex = props.regex,
    whitespace = props.whitespace,
    placeholder = props.placeholder,
    id = props.id,
    className = props.className,
    name = props.name,
    label = props.label,
    right = props.right,
    left = props.left,
    onlyError = props.onlyError,
    disabled = props.disabled;
  var _useField = (0, _formik.useField)(name),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var error = meta.error,
    touched = meta.touched;
  var setValue = helpers.setValue;
  var handleChange = (0, _react.useCallback)(function (e) {
    var target = e.target;
    var value = target.value.replace(regex, '');
    var clipped = getClipped(limit, value);
    if (whitespace) {
      var clean = clipped.replace(whiteSpaceRegex, ' ');
      setValue(clean);
    } else {
      setValue(clipped);
    }
  }, [setValue, whitespace]);
  var hasNotValue = (0, _isEmpty2["default"])(field.value);
  var hasError = getHasError(onlyError, error, touched);
  var icn = (0, _classnames["default"])('form-control', hasError && 'is-invalid', right && 'input-group-br-no', left && 'input-group-bl-no');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(className || '', " ")
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('col-form-label', hasError ? 'text-danger' : hasNotValue && 'empty'),
    htmlFor: id
  }, label), /*#__PURE__*/_react["default"].createElement("input", _extends({
    placeholder: placeholder || label,
    className: icn
  }, field, {
    value: field.value || '',
    onChange: handleChange,
    disabled: disabled
  })), hasError && /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('col-form-error', hasError && error && 'text-danger'),
    htmlFor: id
  }, error));
}
AlphaInput.propTypes = {
  onlyError: _propTypes["default"].bool,
  regex: _propTypes["default"].any,
  whitespace: _propTypes["default"].bool,
  limit: _propTypes["default"].number
};
AlphaInput.defaultProps = {
  onlyError: false,
  regex: noAlpha,
  whitespace: true,
  limit: 0
};
var _default = exports["default"] = AlphaInput;